<div class="container py-4">
    <!-- Header Section -->
    <div class="card mb-4 border table-border-color">
      <div class="card-body">
        <p class="fs-6 fw-bold text-xxs">ENTITY</p>
        <p class="mb-1 text-xxs">CURRENT STATUS</p>
        <span class="status-badge bg-danger bg-opacity-10 text-white mb-4 text-xxs">Non-Compliant</span>

        <p class="mb-1 text-xxs mt-2">ALERT TYPE</p>
        <p class="fw-bold mb-2 text-xxs">Non-Compliant</p>

        <p class="mb-1 text-xxs ">DETECTED :</p>
        <p class="mb-0 text-xxs fw-bold">July 01, 2025</p>
      </div>
    </div>

    <!-- Recipients Section -->
    <div class="card p-3 mb-5 border table-border-color">
      <div class="table-responsive">
        <table class="table table-hover">
          <thead class="custom-header">
            <tr>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Recipient</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Delivery Status</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Read Status</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Last Activity</th>
              <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-start ps-3">Accuracy</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="recipient in recipients" :key="recipient.email">
              <td class="text-xxs text-start">
                <p class="text-xxs text-start">{{ recipient.name }}</p>
                <p class="text-muted text-xxs mb-0">{{ recipient.title }} • {{ recipient.email }}</p>
              </td>
              <td class="text-xxs text-start">{{ recipient.deliveryStatus }}</td>
              <td class="text-xxs text-start">{{ recipient.readStatus }}</td>
              <td class="text-xxs text-start">{{ recipient.lastActivity }}</td>
              <td class="text-xxs text-start">{{ recipient.accuracy }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>